const domain = 'https://peekage.com';

/**
 * @param {{ id?: string, name?: string, uri?: string } | null | undefined} currentPage
 */
const breadcrumb = (currentPage) => {
    const crumbs = [
        {
            uri: '',
            name: 'Peekage',
        },
    ];

    const hasPageCrumb = Boolean(
        currentPage
        && (typeof currentPage.name === 'string' || typeof currentPage.uri === 'string')
        && (currentPage.name || currentPage.uri),
    );

    if (hasPageCrumb && currentPage) {
        crumbs.push({
            uri: currentPage.uri || '',
            name: currentPage.name || '',
        });
    }

    return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        '@id': currentPage?.id || `${domain}/#breadcrumb`,
        itemListElement: crumbs.map((page, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: page.name,
            // Keep trailing slash on the homepage URL for consistency with canonicals.
            item: page.uri ? `${domain}${page.uri}` : `${domain}/`,
        })),
    };
};

export {
    breadcrumb,
};
